<template>
  <div>
    <Card>
      <p slot="title"> Omset List </p>

      <Button icon="ios-upload-outline" type="success" slot="extra" size="small"
        @click="isModalUploadOmset = true, getOmsetCommodities()">
        <span>Upload Omset</span>
      </Button>

      <!-- <Button :disabled="omsetData.length < 1" :loading="isPrintOmset" icon="ios-printer-outline" type="default"
        slot="extra" size="small" @click="printOmset()">
        <span v-if="!isPrintOmset">Cetak Omset</span>
        <span v-else>Sedang diproses.....</span>
      </Button> -->

      <Row type="flex" justify="space-between">
        <Col span="10">
        <ButtonGroup class="custom-group-parent">
          <Button class="custom-group">Tanggal Omset</Button>
          <DatePicker v-model="omsetDateSelected" type="daterange" placeholder="Select date" style="width: 100%" />
        </ButtonGroup>
        </Col>

        <Col span="12">
        <Button type="primary" icon="ios-search" @click="getOmsetFileList()">
          <span>Cari</span>
        </Button>
        </Col>

        <Col span="1">
        <Spin size="large" v-show="isLoadingOmsetList"></Spin>
        </Col>
      </Row>

      <br />

      <Card>
        <Table :columns="columnsDataTableFile" :data="omsetFile" :loading="isLoadingOmsetFileList"></Table>
      </Card>
    </Card>

    <!-- Modal upload omset -->
    <Modal v-model="isModalUploadOmset" width="60%" @on-cancel="afterUploadFileOmset">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="information-circled"></Icon>
        <span>Upload File Omset</span>
      </p>
      <Form ref="uploadFileForm" :model="formUploadOmset">
        <Form-item prop="comodityType">
          <Row type="flex" justify="space-between">
            <Col span="12">
              <label>Pilih Tipe Komoditas :</label>
              <Select v-model="commodity_name" placeholder="Select" clearable filterable >
                <Option v-for="commodity in commodities" :value="commodity.commodity_name" :key="commodity.id">{{
                  commodity.commodity_name }}</Option>
              </Select>
            </Col>
          </Row>
        </Form-item>

        <Form-item prop="file" v-show="commodity_name != null">
          <Upload type="drag" ref="upload" name="fileUploaded" :action="serverUrlUploadOmset"
            :before-upload="(file) => handleBeforeUploadOmset(file)">
            <div class="custom-upload">
              <Icon type="ios-cloud-upload" size="20" style="color: #3399ff"></Icon>
              <p>Click or drag files here to upload</p>
            </div>
          </Upload>
          <Progress :percent="pValueOmset" :stroke-width="20" v-show="isProgressOmset" />
        </Form-item>
      </Form>

      <div slot="footer">
        <Button type="primary" @click="afterUploadFileOmset">
          <span>OK</span>
        </Button>
      </div>
    </Modal>

    <!-- Modal upload biaya lainnya -->
    <Modal v-model="isModalUploadBiayaLainnya" width="60%" @on-cancel="afterUploadFileBiayaLainnya">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="information-circled"></Icon>
        <span>Upload File Biaya Lainnya</span>
      </p>
      <Form ref="uploadFileForm" :model="formUploadBiayaLainnya">
        <Form-item prop="comodityType">
          <Row type="flex" justify="space-between">
            <Col span="12">
              <label>Komoditas</label>
              <span style="margin-left: 2rem;"> : &nbsp; {{ formUploadBiayaLainnya.commodity_name }}</span>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span="12">
              <label>File Omset</label>
              <span style="margin-left: 2rem;"> : &nbsp; [ ID: {{ formUploadBiayaLainnya.id }} ] - {{ formUploadBiayaLainnya.filename }}</span>
            </Col>
          </Row>
        </Form-item>

        <Form-item prop="file">
          <Upload type="drag" ref="upload" name="fileUploaded" :action="serverUrlUploadBiayaLainnya"
            :before-upload="(file) => handleBeforeUploadBiayaLainnya(file)">
            <div class="custom-upload">
              <Icon type="ios-cloud-upload" size="20" style="color: #3399ff"></Icon>
              <p>Click or drag files here to upload</p>
            </div>
          </Upload>
          <Progress :percent="pValueBiayaLainnya" :stroke-width="20" v-show="isProgressBiayaLainnya" />
        </Form-item>
      </Form>

      <div slot="footer">
        <Button type="primary" @click="afterUploadFileBiayaLainnya">
          <span>OK</span>
        </Button>
      </div>
    </Modal>

    <!-- Modal show add detail -->
    <cHotOmsetAddDetail :isModalAddDetail="isModalAddDetail" :dataHot="omsetRow" @dismiss-modal="closeSubmitModal" />

    <!-- Modal show detail -->
    <Modal v-model="isModalDetail" title="Detail(s)" width="90%">
      <p slot="header" style="color:#f90;text-align:center">
        <Icon type="ios-paper"></Icon>
        <span>Detail(s)</span>
      </p>

      <Card>
        <Table :columns="columnsDataDetail" :data="omsetDetail"></Table>
      </Card>
    </Modal>

    <!-- Modal delete header -->
    <Modal v-model="isModalDeleteHeader" ok-text="Ya" cancel-text="Tidak" @on-cancel="confirmDescriptionHeader = ''">
      <p slot="header" style="color:#ed3f14;text-align:center">
        <Icon type="ios-information"></Icon>
        <span>Konfirmasi</span>
      </p>

      <p>Apakah anda yakin ingin menghapus omset?</p>
      <br />
      <div>
        <i> Ketik <b>{{ deleteHeader.containerNumber }}</b> untuk melanjutkan !</i>
        <Input v-model="deleteHeader.id" style="display: none;"></Input>
        <Input v-model="confirmDescriptionHeader" />
      </div>

      <div slot="footer">
        <Button type="error" long
          v-show="(deleteHeader.containerNumber).toUpperCase() == confirmDescriptionHeader.toUpperCase()"
          @click="confirmDeleteHeader">Hapus</Button>
      </div>
    </Modal>

    <!-- Modal edit header -->
    <Modal v-model="isModalEditHeader" width="90%">
      <p slot="header" style="color:#2cb7f5;text-align:center">
        <Icon type="edit"></Icon>
        <span>Edit Omset</span>
      </p>

      <Card>
        <Form ref="editHeader" :model="editHeader">
          <Form-item>
            <div class="edit-header-grid">
              <div>
                <label for="containerNumber">Container Number :</label><br>
                <Input v-model="editHeader.containerNumber" placeholder="Container Number"></Input>
              </div>
              <div>
                <label for="sumOfVol">Sum of Vol :</label><br>
                <Input v-model="editHeader.sumOfVol" placeholder="Sum of Vol"></Input>
              </div>
              <div>
                <label for="sumOfUYAD">Sum of UYAD :</label><br>
                <Input v-model="editHeader.sumOfUYAD" placeholder="Sum of Uyad"></Input>
              </div>
              <div>
                <label for="pib">PIB :</label><br>
                <Input v-model="editHeader.pib" placeholder="PIB"></Input>
              </div>
              <div>
                <label for="notul">Notul :</label><br>
                <Input v-model="editHeader.notul" placeholder="Notul"></Input>
              </div>
              <div>
                <label for="opsPort">Ops. Pelabuhan :</label><br>
                <Input v-model="editHeader.opsPort" placeholder="Ops. Pelabuhan"></Input>
              </div>
              <div>
                <label for="trucking">Trucking :</label><br>
                <Input v-model="editHeader.trucking" placeholder="Trucking"></Input>
              </div>
              <div>
                <label for="daop">DAOP :</label><br>
                <Input v-model="editHeader.daop" placeholder="DAOP"></Input>
              </div>
              <div>
                <label for="demurrage">Demurrage :</label><br>
                <Input v-model="editHeader.demurrage" placeholder="Demurrage"></Input>
              </div>
              <div>
                <label for="reExport">Re-Export :</label><br>
                <Input v-model="editHeader.reExport" placeholder="Re-Export"></Input>
              </div>
              <div>
                <label for="ship_cont_gz">Kapal/Cont. GZ :</label><br>
                <Input v-model="editHeader.shipContGZ" placeholder="Kapal/Cont. GZ"></Input>
              </div>
              <div>
                <label for="form_e">Form E :</label><br>
                <Input v-model="editHeader.formE" placeholder="Form E"></Input>
              </div>
              <div>
                <label for="ls">LS :</label><br>
                <Input v-model="editHeader.ls" placeholder="LS"></Input>
              </div>
            </div>
          </Form-item>
        </Form>
      </Card>

      <div slot="footer">
        <Button v-show="true" type="primary" :loading="isLoadingEditHeader" @click="postUpdateHeader">
          <span v-if="!isLoadingEditHeader">Submit</span>
          <span v-else>On process.....</span>
        </Button>
      </div>
    </Modal>

    <!-- Modal delete detail -->
    <Modal v-model="isModalDeleteDetail" ok-text="Ya" cancel-text="Tidak" @on-cancel="confirmDescriptionDetail = ''">
      <p slot="header" style="color:#ed3f14;text-align:center">
        <Icon type="ios-information"></Icon>
        <span>Konfirmasi</span>
      </p>

      <p>Apakah anda yakin ingin menghapus detail omset?</p>
      <br />
      <div>
        <i> Ketik <b>{{ deleteDetail.containerNumber }}</b> untuk melanjutkan !</i>
        <Input v-model="deleteDetail.id" style="display: none;"></Input>
        <Input v-model="confirmDescriptionDetail" />
      </div>

      <div slot="footer">
        <Button type="error" long
          v-show="(deleteDetail.containerNumber).toUpperCase() == confirmDescriptionDetail.toUpperCase()"
          @click="confirmDeleteDetail">Hapus</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { HTTP } from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'

import cHotOmsetAddDetail from '@/components/omset/cHotOmsetAddDetail';
import expandRow from '@/components/omset/TableExpand.vue';

const numeral = require('numeral');

export default {
  components: { cHotOmsetAddDetail, expandRow },
  data() {
    return {
      // upload omset
      commodities: [],
      commodity_name: null,
      isModalUploadOmset: false,
      formUploadOmset: {},
      serverUrlUploadOmset: '',
      isProgressOmset: false,
      pValueOmset: 0,
      isLoadingOmsetFileList: false,
      columnsDataTableFile: [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => {
            return h(expandRow, {
              props: {
                column: this.columnsDataTable,
                row: params.row.omset
              }
            })
          }
        },
        {
          title: "Created At",
          key: "created_at",
          align: "center",
          // width: 200,
        },
        {
          title: "Created By",
          key: "created_by",
          align: "center",
          // width: 200,
        },
        {
          title: "Commodity",
          key: "commodity_name",
          align: "center",
          // width: 200,
        },
        {
          title: 'File Omset',
          key: 'filename',
          align: 'center',
          // width: 200,
          render: (h, params) => {
            const { row } = params

            return h('div', [
              h('a', {
                style: {
                  textDecoration: 'underline',
                  color: '#2d8cf0 !important'
                },
                on: {
                  click: () => {
                    this.downloadFileOmset(row.filename)
                  }
                }
              }, row.filename)
            ]);
          }
        },
        {
          title: 'File Biaya Lainnya',
          key: 'filename_others',
          align: 'center',
          // width: 200,
          render: (h, params) => {
            const { row } = params
            if (row.filename_others == '-') return h('div', ['-']);

            return h('div', [
              h('a', {
                style: {
                  textDecoration: 'underline',
                  color: '#2d8cf0 !important'
                },
                on: {
                  click: () => {
                    this.downloadFileBiayaLainnya(row.filename_others)
                  }
                }
              }, row.filename_others)
            ]);
          }
        },
        {
          title: 'Action(s)',
          key: 'actions1',
          align: 'center',
          width: 300,
          // fixed: 'right',
          render: (h, params) => {
            const { row } = params

            return h('div', [
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small',
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.isModalUploadBiayaLainnya = true
                    this.formUploadBiayaLainnya = row
                  }
                }
              }, [
                h('Icon', { props: { type: 'ios-loop-strong' }, style: { marginRight: '4px' } }),
                'Upload Biaya Lainnya'
              ]),
              h('Button', {
                props: {
                  type: 'default',
                  size: 'small',
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.printOmset(row.commodity_name, row.omset)
                  }
                }
              }, [
                h('Icon', { props: { type: 'ios-printer-outline' }, style: { marginRight: '4px' } }),
                'Cetak Omset'
              ])
            ])
          }
        },
      ],
      omsetFile: [],

      // upload biaya lainnya
      isModalUploadBiayaLainnya: false,
      formUploadBiayaLainnya: {},
      serverUrlUploadBiayaLainnya: '',
      isProgressBiayaLainnya: false,
      pValueBiayaLainnya: 0,

      // data header
      omsetDateSelected: [],
      isLoadingOmsetList: false,
      columnsDataTable: [
        {
          title: "Container Number",
          key: "containerNumber",
          width: 150,
          align: "center"
        },
        // {
        //   title: "Branch",
        //   key: "branch",
        //   width: 150
        // },
        {
          title: "Sum of Vol",
          key: "sumOfVol",
          width: 120,
          align: "center"
        },
        {
          title: "Sum of UYAD",
          key: "sumOfUYAD",
          width: 130,
          align: "center"
        },
        {
          title: "PIB",
          key: "pib",
          width: 110,
          align: "center"
        },
        {
          title: "Notul",
          key: "notul",
          width: 110,
          align: "center"
        },
        {
          title: "Ops. Pelabuhan",
          key: "opsPort",
          width: 150,
          align: "center"
        },
        {
          title: "Trucking",
          key: "trucking",
          width: 110,
          align: "center"
        },
        {
          title: "DAOP",
          key: "daop",
          width: 110,
          align: "center"
        },
        {
          title: "Demurrage",
          key: "demurrage",
          width: 120,
          align: "center"
        },
        {
          title: "Re-Export",
          key: "reExport",
          width: 110,
          align: "center"
        },
        {
          title: "Kapal/Cont. GZ",
          key: "shipContGZ",
          width: 150,
          align: "center"
        },
        {
          title: "Form E",
          key: "formE",
          width: 110,
          align: "center"
        },
        {
          title: "LS",
          key: "ls",
          width: 110,
          align: "center"
        },
        {
          title: 'Action(s)',
          key: 'actions2',
          width: 100,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            const { row } = params

            return h('div', [
              // h('Button', {
              //   props: {
              //     type: 'success',
              //     size: 'small',
              //   },
              //   style: {
              //     marginRight: '5px'
              //   },
              //   on: {
              //     click: () => {
              //       this.showModalAddDetail(row)
              //     }
              //   }
              // }, [
              //   h('Icon', { props: { type: 'android-add-circle' }, style: { marginRight: '4px' } }),
              //   'Add Detail'
              // ]),
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small',
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.showModalDetail(row)
                  }
                }
              }, 'Detail'),
              // h('Button', {
              //   props: {
              //     type: 'info',
              //     size: 'small',
              //   },
              //   style: {
              //     marginRight: '5px'
              //   },
              //   on: {
              //     click: () => {
              //       this.showModalEditHeader(row)
              //     }
              //   }
              // }, 'Edit'),
              // h('Button', {
              //   props: {
              //     type: 'error',
              //     size: 'small',
              //   },
              //   style: {
              //     marginRight: '5px'
              //   },
              //   on: {
              //     click: () => {
              //       this.showModalDeleteHeader(row)
              //     }
              //   }
              // }, 'Hapus'),
            ])
          }
        }
      ],
      omsetData: [],

      // data header per row
      isModalAddDetail: false,
      omsetRow: {},

      // data print
      isPrintOmset: false,
      omsetPrint: [],

      // data detail
      isModalDetail: false,
      columnsDataDetail: [
        {
          title: "Container Number",
          key: "containerNumber",
          width: 150,
          align: "center"
        },
        {
          title: "Branch",
          key: "branch",
          width: 150
        },
        {
          title: "Sum of Vol",
          key: "sumOfVol",
          width: 120,
          align: "center"
        },
        {
          title: "Sum of UYAD",
          key: "sumOfUYAD",
          width: 130,
          align: "center"
        },
        {
          title: "PIB",
          key: "pib",
          width: 100,
          align: "center"
        },
        {
          title: "Notul",
          key: "notul",
          width: 100,
          align: "center"
        },
        {
          title: "Ops. Pelabuhan",
          key: "opsPort",
          width: 150,
          align: "center"
        },
        {
          title: "Trucking",
          key: "trucking",
          width: 100,
          align: "center"
        },
        {
          title: "DAOP",
          key: "daop",
          width: 100,
          align: "center"
        },
        {
          title: "Demurrage",
          key: "demurrage",
          width: 120,
          align: "center"
        },
        {
          title: "Re-Export",
          key: "reExport",
          width: 100,
          align: "center"
        },
        {
          title: "Kapal/Cont. GZ",
          key: "shipContGZ",
          width: 150,
          align: "center"
        },
        {
          title: "Form E",
          key: "formE",
          width: 100,
          align: "center"
        },
        {
          title: "LS",
          key: "ls",
          width: 100,
          align: "center"
        },
        // {
        //   title: 'Action(s)',
        //   key: 'actions',
        //   width: 150,
        //   align: 'center',
        //   fixed: 'right',
        //   render: (h, params) => {
        //     const { row } = params

        //     return h('div', [
        //       // h('Button', {
        //       //   props: {
        //       //     type: 'info',
        //       //     size: 'small',
        //       //   },
        //       //   style: {
        //       //     marginRight: '5px'
        //       //   },
        //       //   on: {
        //       //     click: () => {
        //       //       this.showModalEditDetail(row)
        //       //     }
        //       //   }
        //       // }, 'Edit'),
        //       h('Button', {
        //         props: {
        //           type: 'error',
        //           size: 'small',
        //         },
        //         style: {
        //           marginRight: '5px'
        //         },
        //         on: {
        //           click: () => {
        //             this.showModalDeleteDetail(row)
        //           }
        //         }
        //       }, 'Hapus'),
        //     ])
        //   }
        // }
      ],
      omsetDetail: [],

      // delete header
      isModalDeleteHeader: false,
      deleteHeader: {
        id: '',
        containerNumber: ''
      },
      confirmDescriptionHeader: '',

      // edit header
      isModalEditHeader: false,
      editHeader: {},
      isLoadingEditHeader: false,

      // delete detail
      isModalDeleteDetail: false,
      deleteDetail: {
        id: '',
        containerNumber: ''
      },
      confirmDescriptionDetail: '',
    }
  },
  methods: {
    // upload omset
    getOmsetCommodities: function () {
      HTTP.get("omset/commodities")
        .then(response => {
          this.commodities = response.data;
        })
        .catch(e => {
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 5
          });
        });
    },
    handleBeforeUploadOmset(file) {
      const timestamp = Date.now();
      const extension = file.name.split('.').pop();
      const newFileName = `OMSET-${timestamp}.${extension}`;
      const renamedFile = new File([file], newFileName, { type: file.type });

      const formData = new FormData();
      formData.append('file', renamedFile);
      formData.append('commodity_name', this.commodity_name);

      this.isProgressOmset = true;
      this.pValueOmset = Math.floor(Math.random() * 100); // Returns a random integer from 0 to 99:

      HTTP
        .post('/oss/omset-upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(response => {
          console.log({ response });

          this.pValueOmset = 100;
          this.$Notice.success({ title: "File berhasil di upload !" });

          this.getOmsetFileList();
        })
        .catch(e => {
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 5
          });
        })

      return false; // Kembalikan false untuk mencegah unggahan otomatis
    },
    afterUploadFileOmset: function () {
      this.pValueOmset = 0
      this.isProgressOmset = false
      this.isModalUploadOmset = false
    },
    getOmsetFileList: function () {
      let createdFrom = null;
      let createdTo = null;

      if (this.omsetDateSelected[0] != "" && this.omsetDateSelected[0] != null) {
        createdFrom = moment(this.omsetDateSelected[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
        createdTo = moment(this.omsetDateSelected[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
      }

      let payload = {
        createdFrom: createdFrom,
        createdTo: createdTo
      }

      this.isLoadingOmsetFileList = true;
      HTTP.post('omset/file-list', payload)
        .then(response => {
          console.log({ response });

          this.omsetFile = _.map(response.data, (item) => {
            return {
              id: item.id,
              created_at: item.created_at ? this.showDateFormatted(item.created_at) : '-',
              created_by: item.created_by ? item.created_by : '-',
              commodity_name: item.commodity_name ? item.commodity_name : '-',
              filename: item.filename ? item.filename : '-',
              filename_others: item.filename_others ? item.filename_others : '-',
              omset: item.omset ? item.omset : [],
            }
          });

          this.isLoadingOmsetFileList = false;
        })
        .catch(e => {
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 5
          });
        });
    },
    downloadFileOmset: function (fileName) {
      const payload = { file_name: fileName }

      HTTP
        .post('oss/omset-download', payload)
        .then(response => {
          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');

          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch(e => {
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 5
          });
        })
    },

    // upload biaya lainnya
    handleBeforeUploadBiayaLainnya(file) {
      const timestamp = Date.now();
      const extension = file.name.split('.').pop();
      const newFileName = `BIAYA_LAINNYA-${timestamp}.${extension}`;
      const renamedFile = new File([file], newFileName, { type: file.type });

      const formData = new FormData();
      formData.append('file', renamedFile);
      formData.append('omset_file_id', this.formUploadBiayaLainnya.id);

      this.isProgressBiayaLainnya = true;
      this.pValueBiayaLainnya = Math.floor(Math.random() * 100); // Returns a random integer from 0 to 99:

      HTTP
        .post('/oss/omset-biaya-lainnya-upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(response => {
          console.log({ response });

          this.pValueBiayaLainnya = 100;
          this.$Notice.success({ title: "File berhasil di upload !" });

          this.getOmsetFileList();
        })
        .catch(e => {
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 5
          });
        })

      return false; // Kembalikan false untuk mencegah unggahan otomatis
    },
    afterUploadFileBiayaLainnya: function () {
      this.pValueBiayaLainnya = 0
      this.isProgressBiayaLainnya = false
      this.isModalUploadBiayaLainnya = false
    },

    showDateFormatted: function (stringToFormat) {
      let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD HH:mm:ss').toDate();
      return moment(dateToFormat).format("DD MMM YYYY HH:mm:ss")
    },
    getOmsetList: function () {
      let omsetDateFrom = null;
      let omsetDateTo = null;

      // handle omset date
      if (this.omsetDateSelected[0] != "" && this.omsetDateSelected[0] != null) {
        omsetDateFrom = moment(this.omsetDateSelected[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
        omsetDateTo = moment(this.omsetDateSelected[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
      }

      let payload = {
        omsetDateFrom: omsetDateFrom,
        omsetDateTo: omsetDateTo
      }

      console.log({ payload });

      this.isLoadingOmsetList = true;
      HTTP.post('omset/list', payload)
        .then(response => {
          console.log({ response });

          this.omsetData = _.map(response.data, (item) => {
            return {
              id: item.id,
              containerNumber: item.container_number ? item.container_number : '-',
              branch: item.branch ? item.branch : '-',
              sumOfVol: item.sum_of_vol ? numeral(item.sum_of_vol).format('0,0.000') : '-',
              sumOfUYAD: item.sum_of_uyad ? numeral(item.sum_of_uyad).format('0,0') : '-',
              pib: item.pib ? numeral(item.pib).format('0,0') : '-',
              notul: item.notul ? numeral(item.notul).format('0,0') : '-',
              opsPort: item.ops_port ? numeral(item.ops_port).format('0,0') : '-',
              trucking: item.trucking ? numeral(item.trucking).format('0,0') : '-',
              daop: item.daop ? numeral(item.daop).format('0,0') : '-',
              demurrage: item.demurrage ? numeral(item.demurrage).format('0,0') : '-',
              reExport: item.re_export ? numeral(item.re_export).format('0,0') : '-',
              shipContGZ: item.ship_cont_gz ? numeral(item.ship_cont_gz).format('0,0') : '-',
              formE: item.form_e ? numeral(item.form_e).format('0,0') : '-',
              ls: item.ls ? numeral(item.ls).format('0,0') : '-',
              omsetDetail: item.omset_detail
            }
          });

          this.omsetPrint = response.data;
          this.isLoadingOmsetList = false;
        })
        .catch(e => {
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 5
          });
        });
    },

    // data add detail
    showModalAddDetail: function (data) {
      console.log({ data })

      this.omsetRow = data
      this.isModalAddDetail = true
    },
    closeSubmitModal: function () {
      this.omsetRow = {}
      this.isModalAddDetail = false
      this.getOmsetFileList()
    },

    // data print
    printOmset: function (commodity_name, omset) {
      let commodity = commodity_name
      let dataOmset = omset

      this.isPrintOmset = true
      HTTP.post('omset/print-to-excel', { dataOmset }, {
        responseType: 'blob'
      })
        .then(response => {
          const blob = new Blob([response.data], {
            type: 'application/vnd.ms-excel'
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `OMSET - `+commodity+` - ${moment(new Date()).format("DDMMYYhhmmss")}.xls`); // name file downloaded
          document.body.appendChild(link);
          link.click();
          link.remove();

          this.isPrintOmset = false;
        })
    },

    // data detail
    showModalDetail: function (data) {
      if (data.omsetDetail) {
        this.omsetDetail = _.map(data.omsetDetail, (item) => {
          return {
            id: item.id,
            containerNumber: item.container_number ? item.container_number : '-',
            branch: item.branch ? item.branch : '-',
            sumOfVol: item.sum_of_vol ? numeral(item.sum_of_vol).format('0,0.000') : '-',
            sumOfUYAD: item.sum_of_uyad ? numeral(item.sum_of_uyad).format('0,0') : '-',
            pib: item.pib ? numeral(item.pib).format('0,0') : '-',
            notul: item.notul ? numeral(item.notul).format('0,0') : '-',
            opsPort: item.ops_port ? numeral(item.ops_port).format('0,0') : '-',
            trucking: item.trucking ? numeral(item.trucking).format('0,0') : '-',
            daop: item.daop ? numeral(item.daop).format('0,0') : '-',
            demurrage: item.demurrage ? numeral(item.demurrage).format('0,0') : '-',
            reExport: item.re_export ? numeral(item.re_export).format('0,0') : '-',
            shipContGZ: item.ship_cont_gz ? numeral(item.ship_cont_gz).format('0,0') : '-',
            formE: item.form_e ? numeral(item.form_e).format('0,0') : '-',
            ls: item.ls ? numeral(item.ls).format('0,0') : '-',
          }
        });
      }

      this.isModalDetail = true
    },

    // delete header
    showModalDeleteHeader: function (data) {
      this.deleteHeader.id = data.id;
      this.deleteHeader.containerNumber = data.containerNumber;

      this.isModalDeleteHeader = true;
    },
    confirmDeleteHeader: function () {
      this.$Loading.start();

      let payload = { id: this.deleteHeader.id }

      console.log({ payload });
      HTTP
        .post('omset/delete', payload)
        .then(response => {
          console.log("post delete response :", response);

          if (response.data) {
            this.isModalDeleteHeader = false;
            this.$Loading.finish();
            this.$Message.success('Omset berhasil dihapus !');
          } else {
            this.isModalDeleteHeader = false;
            this.$Loading.finish();
            this.$Message.error('Omset gagal dihapus !');
          }

          this.getOmsetList();
        })
        .catch(e => {
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 5
          });
        })
    },

    // edit header
    showModalEditHeader: function (data) {
      this.editHeader = data

      this.isModalEditHeader = true
    },
    postUpdateHeader: function () {
      this.isLoadingEditHeader = true;
      this.$Loading.start();

      let payload = { data: this.editHeader }

      console.log({ payload });
      HTTP
        .post('omset/update', payload)
        .then(response => {
          console.log("post update response :", response);

          this.isModalEditHeader = false;
          this.isLoadingEditHeader = false;
          this.$Loading.finish();
          this.$Message.success('Omset berhasil diubah !');
          this.getOmsetList();
        })
        .catch(e => {
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 5
          });
        })
    },

    // delete detail
    showModalDeleteDetail: function (data) {
      console.log({ data });

      this.deleteDetail.id = data.id;
      this.deleteDetail.containerNumber = data.containerNumber;

      this.isModalDeleteDetail = true;
    },
    confirmDeleteDetail: function () {
      this.$Loading.start();

      let payload = { id: this.deleteDetail.id }

      console.log({ payload });
      HTTP
        .post('omset/delete-detail', payload)
        .then(response => {
          console.log("post delete detail response :", response);

          if (response.data) {
            this.isModalDeleteDetail = false;
            this.isModalDetail = false;
            this.$Loading.finish();
            this.$Message.success('Detail omset berhasil dihapus !');
          } else {
            this.isModalDeleteDetail = false;
            this.isModalDetail = false;
            this.$Loading.finish();
            this.$Message.error('Detail omset gagal dihapus !');
          }

          this.getOmsetList();
        })
        .catch(e => {
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 5
          });
        })
    },
  },
  mounted() {
    this.$Loading.config({
      color: '#fff',
      failedColor: '#f0ad4e',
      height: 10
    });
  },
}

</script>

<style scoped>
.edit-header-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 12px 16px;
  align-items: center;
  /* rata tengah vertikal */
}

.edit-header-grid label {
  font-weight: 500;
}

.edit-header-grid input {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// OmsetList.vue?721d09b8